(ns frontend.view.components.form.components.form-switch
  (:require
   [reagent.core :as r]
   [frontend.view.components.form.components.form-label :as form-label]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]))

(defn view
  [{:keys [value] :as view-args}]
  (let [raw-input (r/atom value)
        ;; Save the original value to be referenced later for cancelling
        original-value value]
    (fn
      [{:keys [label type size value intelligence-value wrapper control-id
               edit? switch-info
               set-edit! on-change! on-submit! on-cancel! on-key-down! validate! mandatory?]
        :as   view-args}]
      [rbs/Form
       [rbs/FormGroup
        {:control-id control-id
         :size       size
         :class-name (fu/cs wrapper "form__text")}
        [form-label/view view-args]
        [rbs/InputGroup
         {:class-name "switch__container"
          :style      {:width "100%"}}
         [:label.switch
          [:input
           {:type      "checkbox"
            :checked   (true? (if (nil? value)            ;; use intelligence-value if value is not set
                                intelligence-value
                                value))
            :on-change #(when edit?
                          (on-change! (if (-> %
                                              .-target
                                              .-checked)
                                        true
                                        false))
                          (on-submit! %))}]
          [:span.slider.round]]
         [:span.switch-slider__label switch-info]]]])))
